import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { AnimatedGradient } from '../components/AnimatedGradient';
import { Header } from '../components/Header';
import { HeroBadge } from '../components/HeroBadge';
import { HeroText } from '../components/HeroText';
import { ChatInput } from '../components/ChatInput';
export function LandingPage() {
  return <div className="relative min-h-screen w-full overflow-hidden font-sans selection:bg-orange-200 selection:text-orange-900" data-id="element-257">
      {/* Background */}
      <AnimatedGradient data-id="element-258" />

      {/* Navigation */}
      <Header data-id="element-259" />

      {/* Main Content */}
      <main className="relative z-10 flex flex-col items-center justify-center min-h-screen pt-20 pb-12 px-4 sm:px-6" data-id="element-260">
        <div className="w-full max-w-5xl mx-auto flex flex-col items-center" data-id="element-261">
          {/* Badge */}
          <HeroBadge data-id="element-262" />

          {/* Hero Text */}
          <HeroText data-id="element-263" />

          {/* Interactive Chat Card */}
          <ChatInput data-id="element-264" />
        </div>
      </main>

      {/* Cookie Banner (Visual Only - Bottom Right) */}






    </div>;
}